import { terminalCalculation } from "hooks/terminalSolution/terminalSolutionMappers";
import { uiActions } from "store";
import { TerminalConfigurationOption } from "types/enums";

type isValidAmountToBeBilledValidatorProps = {
	values: { [key: string]: any };
	dispatch: Function;
	amountToBeBillValue?: string | number;
};

type isValidFrontEndPlatformValidatorProps =
	isValidAmountToBeBilledValidatorProps;

export const isValidFrontEndPlatformValidator = ({
	values,
	dispatch,
}: isValidFrontEndPlatformValidatorProps) => {
	if (
		values?.omahaFrontEndPlatform === false &&
		values?.northFrontEndPlatform === false &&
		values?.nashvilleFrontEndPlatform === false &&
		values?.compassFrontEndPlatform === false &&
		values?.buypassFrontEndPlatform === false &&
		values?.otherFrontEndPlatform === false
	) {
		dispatch(
			uiActions.showErrorNotification({
				title: "The Front End Platforms is required to contain at least one option.",
			}),
		);

		return false;
	} else {
		return true;
	}
};

export const isValidAmountToBeBilledValidator = ({
	values,
	dispatch,
	amountToBeBillValue,
}: isValidAmountToBeBilledValidatorProps) => {
	const terminals = Array.isArray(values) ? values : [values];

	let totalAmountToBeBilled = 0;

	if (amountToBeBillValue) {
		totalAmountToBeBilled = parseFloat(amountToBeBillValue.toString());
	} else {
		terminals[0]?.paymentMethods?.forEach(payment => {
			totalAmountToBeBilled += parseFloat(
				payment?.billToInfo?.amountToBeBilled || 0,
			);
		});
	}
	let totalPrice = 0;

	terminals.forEach(value => {
		totalPrice += terminalCalculation({
			terminal: {
				pricePerTerminal: value?.terminal?.pricePerTerminal,
				monthRentalPrice: value?.terminal?.monthRentalPrice,
				equipmentInsurance: value?.terminal?.equipmentInsurance,
				shippingAndHandling: value?.terminal?.shippingAndHandling,
				estimatedTax: value?.terminal?.estimatedTax,
				terminalConfigurationOption:
					value?.terminal?.terminalConfigurationOption,
				quantity: value?.terminal?.quantity,
			},
			terminalAccessories: value?.terminalAccessories,
		});
	});

	const isNewRental =
		terminals[0]?.terminal?.terminalConfigurationOption ===
		TerminalConfigurationOption.NewRental.name;

	const paymentMethodsCount = values?.paymentMethods?.length || 0;

	if (isNewRental && terminals?.length > 0) {
		if (
			// TODO:  Implement lib for rounding
			// for example https://www.npmjs.com/package/big.js
			// https://rwaapps.atlassian.net/browse/RC-10086
			Math.round((totalPrice + Number.EPSILON) * 100) / 100 !==
			totalAmountToBeBilled
		) {
			if (paymentMethodsCount < 2) {
				dispatch(
					uiActions.showErrorNotification({
						title: "Total Amount To Be Billed must equal the sum Rental Price (per month), Equipment Insurance, Shipping and Handling (one time), Estimated Tax and Price Per Accessory(ies)",
					}),
				);
			} else {
				dispatch(
					uiActions.showErrorNotification({
						title: "Total Amount To Be Billies must equal the sum Rental Price (per month), Equipment Insurance, Shipping and Handling (one time), Estimated Tax and Price Per Accessory(ies)",
					}),
				);
			}

			return false;
		}
	} else if (
		// TODO:  Implement lib for rounding
		// for example https://www.npmjs.com/package/big.js
		// https://rwaapps.atlassian.net/browse/RC-10086
		totalAmountToBeBilled !==
			Math.round((totalPrice + Number.EPSILON) * 100) / 100 &&
		terminals.length > 0
	) {
		if (paymentMethodsCount < 2) {
			dispatch(
				uiActions.showErrorNotification({
					title: "Total Amount To Be Billed must equal the sum Price Per Terminal and Price Per Accessory(ies)",
				}),
			);
		} else {
			dispatch(
				uiActions.showErrorNotification({
					title: "Total Amount To Be Billies for all Payees must equal the sum Price Per Terminal and Price Per Accessory(ies)",
				}),
			);
		}

		return false;
	}
	return true;
};
